import type { SVGProps } from "react";
export default function SvgMinus(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-minus-icon lucide-minus"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M5 12h14" />
		</svg>
	);
}
